export class CountDown {
  time: number;
  interval: number;
  timeInterval?: number;
  /**
   * @param time  倒计时 （毫秒数/ms）
   * @param status 倒计时状态
   */
  listen?: ({ time, status }: { time: number; status: string }) => void;
  constructor({ time, interval = 100 }: { [key: string]: number } = {}) {
    this.time = time;
    this.interval = interval;
  }
  /**
   * @param time  倒计时 （毫秒数/ms）
   * @param endTime 结束时间（毫秒数/ms）
   */
  public start(time: number, endTime: number) {
    if (time) {
      this.time = time;
      this.timeInterval = setInterval(() => {
        const nowTime = Date.now();
        const dateTimeDuration = endTime - nowTime;
        const timeDuration = this.time - this.interval;
        this.time =
          dateTimeDuration <= timeDuration ? dateTimeDuration : timeDuration;
        if (this.time <= 0) {
          this.end();
          return;
        }
        if (this.listen) {
          this.listen({
            time: this.time || 0,
            status: "running",
          });
        }
      }, this.interval);
    } else {
      this.end();
    }
  }
  public end() {
    clearInterval(this.timeInterval);
    if (this.listen) {
      this.listen({
        time: this.time <= 0 ? 0 : this.time,
        status: "end",
      });
    }
  }
}
